import { socket } from 'utils/io/socket'

const socketEmit = async (name, data) => {
  return new Promise((resolve, reject) => {
    socket.emit(name, data, (data, message, error) => {
      if (!data.message || error) {
        console.error(error)
        reject(new Error(message))
      } else {
        console.log('Data', data)
        resolve(data)
      }
    })
  })
}

/**
 * Request an audit analysis of the app
 * @param {Object} params - The parameters for the audit request
 * @param {string} params.appId - The ID of the app to audit
 * @param {Function} params.onProgress - A callback function to receive progress updates
 * @param {Function} params.onError - A callback function to receive error messages
 * @returns {Promise<Object>} The audit results containing nestedLists and componentCounts
 */
export const requestAudit = async ({ appId, onProgress, onError }) => {
  console.log('Requesting audit for app', appId)
  await socketEmit('requestAudit', { appId })
  console.log('Audit requested')

  return new Promise((resolve, reject) => {
    const auditData = {}
    const resultAuditHandler = async response => {
      const chunk = response.data
      try {
        if (chunk.error) {
          // console.error('Error processing audit chunk:', chunk.error)
          socket.off('resultAudit', resultAuditHandler)

          if (onError) {
            onError(chunk.error)
          }

          // Reject the promise but don't throw
          reject(new Error(chunk.error))

          return
        }

        auditData[chunk.chunkName] = chunk.payload

        const progress = (chunk.index + 1) / chunk.total
        onProgress(progress)
        // Check if we've received all chunks
        if (chunk.total === chunk.index + 1) {
          console.log('All audit chunks received', auditData)
          socket.off('resultAudit', resultAuditHandler)
          resolve(auditData)
        }
      } catch (error) {
        console.error('Error processing audit chunk:', error)
        socket.off('resultAudit', resultAuditHandler)
        reject(error)
        throw error
      }
    }

    socket.on('resultAudit', resultAuditHandler)
  })
}
